var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.94002 13.78C5.81336 13.78 5.68669 13.7333 5.58669 13.6333C5.39336 13.44 5.39336 13.12 5.58669 12.9267L9.93336 8.58C10.2534 8.26 10.2534 7.74 9.93336 7.42L5.58669 3.07333C5.39336 2.88 5.39336 2.56 5.58669 2.36667C5.78002 2.17333 6.10002 2.17333 6.29336 2.36667L10.64 6.71333C10.98 7.05333 11.1734 7.51333 11.1734 8C11.1734 8.48667 10.9867 8.94667 10.64 9.28667L6.29336 13.6333C6.19336 13.7267 6.06669 13.78 5.94002 13.78Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight16);
export default __webpack_public_path__ + "static/media/arrow-right-16.3b9c9a5c562db43134c95e3ac758e449.svg";
export { ForwardRef as ReactComponent };